import React, { PureComponent } from 'react';
import styled from 'styled-components';

const Img = styled.img`
  height: ${(props) => props.height || "auto"};
  width: ${(props) => props.width || "100%"};
  min-width: ${(props) => props.minWidth || "0"};
  border-radius: ${(props) => props.borderRadius || "0"};
  &:hover{       cursor:pointer;

    /* transition: transform 1s linear; */
    transform: translate(0px, 0px);


transition: transform .3s;  
-o-transition: transform .3s;
-moz-transition: transform .3s;
-webkit-transition: transform .3s;
  }
`;
const ImgOuter = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: ${(props) => props.height || "100%"};
  width: ${(props) => props.width || "100%"};
  padding: ${(props) => props.padding || "15% 5%"};
  margin: ${(props) => props.margin || "0"};
  cursor: ${(props) => props.cursor || "default"};
  ${({ theme }) => theme.media.tablet`
  padding: 8% 5%;
    `}
  ${({ theme }) => theme.media.mobile`
  align-items: center;
  flex-direction: column;
  display: ${(props) => props.displayM};
    `}
`; 
class ImgAtom extends PureComponent {
  render() {
    return (
      <ImgOuter
        width={this.props.width}
        height={this.props.height}
        padding={this.props.padding}
        margin={this.props.margin}
        onClick={this.props.onClick}
        cursor={this.props.cursor}
        displayM ={this.props.displayM}
      >
        <Img
          src={this.props.src}
          onMouseOver ={this.props.onMouseOver}
          onMouseOut ={this.props.onMouseOut}
          width={this.props.imgwidth}
          height={this.props.imgHeight}
          minWidth={this.props.minWidth}
          borderRadius= {this.props.borderRadius}
        ></Img>
      </ImgOuter>
    );
  }
}

export default ImgAtom